// Shared Nanouk avatar URLs. The `?w=200&h=200&fit=crop` suffixes are
// critical — without them browsers can mis-resolve concatenated tokens
// and the avatar fails to load. Keep single, clean URLs.
export const NANOUK_IMAGES = {
    happy: 'https://images.unsplash.com/photo-1767381604151-bae00f2fb337?w=200&h=200&fit=crop',
    icon: 'https://images.unsplash.com/photo-1563889958768-0fa816b019c7?w=200&h=200&fit=crop',
    sleeping: 'https://images.unsplash.com/photo-1593275497414-473e94a9152a?w=200&h=200&fit=crop',
    travel: 'https://images.unsplash.com/photo-1767381604151-bae00f2fb337?w=200&h=200&fit=crop',
    smart: 'https://images.unsplash.com/photo-1563889958768-0fa816b019c7?w=200&h=200&fit=crop',
};
